import { PackageServiceAvailability as Availability } from "../@types";

export const isAvailable = (
  availability: string,
  availabilityOptions?: string[]
): boolean => {
  const availableOptions = Object.assign(
    [],
    [
      Availability.ANY_DOCTOR,
      Availability.ANY_WILLING_DOCTOR,
      Availability.PLAN_DOCTORS,
      Availability.PLAN_DOCTORS_MOST_SERVICES,
      Availability.PLAN_DOCTORS_SOME_SERVICES,
      Availability.PLAN_DOCTORS_WITH_EXCEPTIONS,
      Availability.PROVIDED,
      Availability.PROVIDED_EXTRA_COST,
    ],
    availabilityOptions
  );

  return availableOptions.indexOf(availability as Availability) > -1;
};
